export default __webpack_public_path__ + "static/media/picto-focus.2eda7065.svg";